import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { LocalizationTextOverrideInputSchema } from "./save-localization-text-overrides";

export const translateCoverageText = {
  name: "translateCoverageText" as const,
  input: z.object({
    teamId: zExt.objectId(),
    localizationGroupId: zExt.objectId(),
    sourceLocale: z.string().min(2).max(35),
    includeInactive: z.boolean().optional(),
  }),
  output: z.object({
    textOverrides: z.array(LocalizationTextOverrideInputSchema),
  }),
};
